export default __webpack_public_path__ + "static/media/total-stake.e8dbe895.png";